<template>
  <div>
    <div class="common-forms">
      <a-form :labelAlign="formDatas.labelAlign" :colon="false" :label-col="{ style: { width: formDatas.labelWidth+'px' } }">
        <a-row :gutter="24">
          <a-col :span="8" v-for="(item,index) in formList" :key="index" v-show="item.show">
            <a-form-item :label="item.label"  :label-col="{ style: { width: (item.labelWidth || formDatas.labelWidth)+'px' } }">
              <template v-if="item.type=='input'">
                <a-input v-model:value="item.value" @keyup.enter="changeValues" :allowClear="true" :placeholder="item.placeholder?item.placeholder:'请输入'" />
              </template>
              <template v-else-if="item.type=='select'">
                <a-select v-model:value="item.value" :mode="item.mode" show-search :allowClear="item.clearable=='false'?false:true" @change="changeValues">
                  <a-select-option :value='option.value' v-for='option of item.list' :key='option.value' >{{option.label}}</a-select-option>
                </a-select>
              </template>
              <template v-else-if="item.type=='radio'">
                <a-radio-group v-model:value="item.value" :options="item.list" @change="changeValues" :option-type="item.optionType">
                </a-radio-group>
              </template>
              <template v-else-if="item.type=='daterange'">
                <a-range-picker v-model:value="item.value" valueFormat="YYYY-MM-DD" :allowClear="true" @change="changeValues" style="width:100%" />
              </template>
              <template v-else-if="item.type=='date'">
                <a-date-picker v-model:value="item.value" :allowClear="true" valueFormat="YYYY-MM-DD" @change="changeValues" style="width:100%" />
              </template>
              <template v-else-if="item.type=='month'">
                <a-date-picker v-model:value="item.value" picker="month" :allowClear="true" valueFormat="YYYY-MM" @change="changeValues" style="width:100%" />
              </template>
              <template v-else-if="item.type=='inputRange'">
                <div style="display:flex;align-items:center;">
                  <a-input v-if="item.isNumber" v-model:value="item.value[0]" placeholder="最小值" :allowClear="true" onkeyup="this.value = this.value.replace(/[^\d.]/g,'')" @keyup.enter="changeValues" />
                  <a-input v-else v-model:value="item.value[0]" placeholder="最小值" :allowClear="true" @keyup.enter="changeValues" />
                  <span>-</span>
                  <a-input v-if="item.isNumber" v-model:value="item.value[1]" placeholder="最大值" :allowClear="true" onkeyup="this.value = this.value.replace(/[^\d.]/g,'')" @keyup.enter="changeValues" />
                  <a-input v-else v-model:value="item.value[1]" placeholder="最大值" :allowClear="true" @keyup.enter="changeValues" />
                </div>
              </template>
              <template v-else-if="item.type=='allBlogger'">
              <!-- 不限制权限的，商务可以看到没了绑定关系的博主 -->
                <CpeH5BloggerSearch  v-model="item.value" />
              </template>
              <template v-else-if="item.type=='blogger'">
              <!-- 限制权限，商务只能看到有绑定关系的博主 -->
                <CpeBloggerSearch  v-model="item.value" :mode="item.mode" />
              </template>
              <template v-else-if="item.type=='director'">
                <CpeDirectorSearch  v-model="item.value" :mode="item.mode" :prop="item.prop" />
              </template>
              <template v-else-if="item.type=='cpeProject'">
                <CpeProjectSearch  v-model="item.value" :mode="item.mode" :prop="item.prop" />
              </template>
              <template v-else-if="item.type=='cpePlatform'">
                <CpePlatformSearch  v-model="item.value" :mode="item.mode" />
              </template>
              <template v-else-if="item.type=='cpaProject'">
                <PlatformSearchCpa v-model="item.value" :mode="item.mode" />
              </template>
              <!-- 受邀博主 -->
              <template v-else-if="item.type=='cpaInviteBlogger'">
                <BloggerInviteSearchCpa v-model="item.value" :mode="item.mode" />
              </template>
              <template v-else-if="item.type=='cpaBlogger'">
                <BloggerSearchCpa v-model="item.value" :mode="item.mode" />
              </template>
              <template v-else-if="item.type=='cpaDirector'">
                <DirectorSearchCpa v-model="item.value" :mode="item.mode"/>
              </template>
              <template v-else-if="item.type=='cpaDirectorManager'">
                <DirectorManagerSearchCpa v-model="item.value" />
              </template>
              <template v-else-if="item.type=='cpaKeyword'">
                <KeywordSearchCpa v-model="item.value" />
              </template>
              <!-- 全部的项目，cpa和cpe的 -->
              <template v-else-if="item.type=='allProjects'">
                <AllProjectsSearch v-model="item.value" />
              </template>
              <template v-else-if="item.type=='users'">
                <AllUsersSearch v-model="item.value" />
              </template>
            </a-form-item>
          </a-col>
          <a-col :span="buttonSpan"><a-form-item>
            <div style="text-align: right;">
              <a-button type="primary" ghost @click="onReset">重置</a-button>
              <a-button type="primary" @click="onSearch" style="margin-left:10px;">搜索</a-button>
              <a-button type="primary" shape="circle" v-if="isShowFold" @click="changeFoldStatus" :icon="h(DoubleRightOutlined)" style="margin-left:10px;" :style="{'transform': isFold ? 'rotate(90deg)' : 'rotate(-90deg)'}"></a-button>
            </div>
          </a-form-item></a-col>
        </a-row>
      </a-form>
    </div>

  </div>
</template>
<script lang='ts' setup>
import request from '@/utils/request'
import { DoubleRightOutlined } from '@ant-design/icons-vue';
import { h, ref, defineProps, defineEmits, defineExpose, computed, onMounted, watch, toRaw, watchEffect, nextTick } from 'vue';

import CpeH5BloggerSearch from '@/components/searchComps/CpeH5BloggerSearch.vue';
import CpeBloggerSearch from '@/components/searchComps/CpeBloggerSearch.vue';
import CpeDirectorSearch from '@/components/searchComps/CpeDirectorSearch.vue';
import CpePlatformSearch from '@/components/searchComps/CpePlatformSearch.vue';
import CpeProjectSearch from '@/components/searchComps/CpeProjectSearch.vue';


import DirectorSearchCpa from '@/components/searchComps/DirectorSearchCpa.vue'
import DirectorManagerSearchCpa from '@/components/searchComps/DirectorManagerSearchCpa.vue'
import BloggerInviteSearchCpa from '@/components/searchComps/BloggerInviteSearchCpa.vue'
import BloggerSearchCpa from '@/components/searchComps/BloggerSearchCpa.vue'
import PlatformSearchCpa from '@/components/searchComps/PlatformSearchCpa.vue'
import KeywordSearchCpa from '@/components/searchComps/KeywordSearchCpa.vue'

import AllProjectsSearch from '@/components/searchComps/AllProjectsSearch.vue'
import AllUsersSearch from '@/components/searchComps/AllUsersSearch.vue'

import _ from 'lodash'
/**
 * formList 的类型
 * input--输入框
 * select--下拉框（multiple为true时，value是数组，list是下拉数据，默认label，value）
 * date -- 时间 已经格式化 YYYY-MM-DD
 * daterange -- 时间区间 value是数组，两个值 已经格式化 YYYY-MM-DD
 * inputRange 两个区间值，字段为fields，里面是两个对应的字段，value也是数组，index对应
 * selectDatas -- 点击会出现弹窗，选择后将数据填充到输入框里。
 */

import { useRoute } from 'vue-router';
import { useStore } from 'vuex'

import dayjs from 'dayjs';

const store = useStore()

const emits = defineEmits(['searchDatas','searchDatasByBtn'])
const props = defineProps({
  formDatas: {
    type: Object,
  }
})
const route = useRoute()
const isShowFold = ref(true)
const formList = ref([])

const isFold = ref(true)
const isInit = ref(true)

const user_role = computed(() => store.state.user.role)

const buttonSpan = computed(()=> {
  let total = formList.value.filter(v=>v.show).length
  let span = (3-(total % 3)) * 8 || 24
  return span
})

const changeValues = ($event = null, item = null, isSearchBtn = false) => {
  let params = {}
  let list = toRaw(formList.value)
  list.forEach(v=>{
    if (v.type=='inputRange' || v.type=='daterange' || v.type=='monthrange') {
      let result1 = ''
      let result2 = ''
      console.log(123, v.value)
      // 有时间的，需要判断是否有length值
      if (v.value && v.value.length) {
        // 兼容原来cpa项目的时间
        if (v.type=='daterange' && v.timeStr) {
          params[v.field] = [dayjs(v.value[0]).unix(), dayjs(v.value[1]).unix()].join(',')
        } else if (v.type=='daterange' && v.needString) {
          params[v.field] = [v.value[0], v.value[1]].filter(Boolean).join(',')
        } else if (v.type=='inputRange' && v.needString) {
          params[v.field] = [v.value[0], v.value[1]].filter(Boolean).join(',')
        } else {
          // 数字类型的会转换为数字类型
          result1 = v.isNumber && v.value[0] ? parseFloat(v.value[0]) : v.value[0]
          result2 = v.isNumber && v.value[1] ? parseFloat(v.value[1]) : v.value[1]
          params[v.fields[0]] = result1
          params[v.fields[1]] = result2
        }
      }
    } else if (v.type=='date') {
      if (v.value) {
        params[v.field] = v.timeStr ? dayjs(v.value).unix() : dayjs(v.value).format('YYYY-MM-DD')
      } else {
        params[v.field] = ''
      }
    } else if (v.mode=='multiple'&&v.needString) {
      params[v.field] = v.value && v.value.length ? v.value.join(',') : ''
    } else if (v.type=='input'&&v.needMore) {
      let result =  v.value?.split(',').map(v=>v.trim())
      params[v.field] = v.needArray ? result : result.join(',')
    }else {
      params[v.field] = v.value
    }
  })
  console.log('params', params)
  emits('searchDatas', params)
}
const onSearch = () => {
  changeValues(null,null,true)
}
function onReset() {
  formList.value = _.cloneDeep(props.formDatas?.data)
  setHeight()
  onSearch()
}
const initSelects = () => {
  if (!formList.value.length) return false
  formList.value.forEach((v, i) => {
    if (v.type=='select' && v.requestUrl) {
      getSelectDatas(v, i)
    }
    if (route.query && Object.keys(route.query).includes(v.field) && isInit.value) {
      v['value'] = route.query[v.field]
    }
  })
  setHeight()
  if (isInit.value) {
    isInit.value = false
    onSearch()
  }
}

const setHeight = () => {
  if (formList.value.length > 5) {
    isShowFold.value = true
    isFold.value = true
    formList.value = formList.value.map((v,i)=>{
      return {
        ...v,
        show: i<5
      }
    })
  } else {
    isShowFold.value = false
    isFold.value = false
    formList.value = formList.value.map((v,i)=>{
      return {
        ...v,
        show: true
      }
    })
  }

}

function getSelectDatas(item, index) {
  request.get(item.requestUrl).then(({data})=> {
    console.log(12345,data)
    if (item.props) {
      if (data.list && data.list.length) {
        data.list = data.list.map(v=>{
          v['label'] = v[item.props.label]
          v['value'] = v[item.props.value]
          return v
        })
        formList.value[index].list = data.list
      } else if (data && data.length) {
        data = data.map(v=>{
          if (typeof v == 'string') {
            return {label:v,value:v}
          }
          v['label'] = v[item.props.label]
          v['value'] = v[item.props.value] || v['value']
          return v
        })
        formList.value[index].list = data
      }
      if (item.distinct) {
        formList.value[index].list = Array.from(new Set(formList.value[index].list.map(item => item.value))).map(value => {
          return formList.value[index].list.find(item => item.value === value);
        })
      }
      
    } else if (item.isArrayData && data.length) {
      let res = data.map(v=>({value:v,label:v}))
      console.log(123, res)
      formList.value[index].list = [...res]
    }
    
  })
}


onMounted(async () => {
  await getForms()
  if (formList.value.length) {
    initSelects()
  }
  
})

async function getForms() {

  // item.role ? item.role?.includes(user_role)
  let list = _.cloneDeep(props.formDatas?.data)
  list = list.filter(item=> {
    return item.role ? item.role?.includes(user_role.value) : true
  })

  formList.value = _.cloneDeep(list)
}

function changeFoldStatus() {
  isFold.value = !isFold.value
  formList.value = formList.value.map((v,i)=>{
    return {
      ...v,
      show: isFold.value ? i<5 : true
    }
  })
}

defineExpose({
  changeValues,
  onReset
})

</script>
<style lang='scss' scoped>

</style>